import { render, staticRenderFns } from "./ModalPaymentStatus.vue?vue&type=template&id=0527ab36&"
import script from "./ModalPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports